import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: './pages/home/home.module#HomePageModule' },
  { path: 'whatsapp', loadChildren: './pages/about/about.module#AboutPageModule' },
  { path: 'WhatsApp', loadChildren: './pages/about/about.module#AboutPageModule' },
  { path: 'chat', loadChildren: './pages/about/about.module#AboutPageModule' },
  { path: 'contact', loadChildren: './pages/contact/contact.module#ContactPageModule' },
  { path: 'asesor', loadChildren: './pages/advisor/advisor.module#AdvisorPageModule' },
  { path: 'grupo', loadChildren: './pages/group/group.module#GroupPageModule' },
  { path: 'transferencia', loadChildren: './pages/payment/payment.module#PaymentPageModule' },
  { path: 'oxxo', loadChildren: './pages/payment/payment.module#PaymentPageModule' },
  { path: 'tarjeta', loadChildren: './pages/stripe-checkout/stripe-checkout.module#StripeCheckoutPageModule' },
  { path: 'pago-confirmado', loadChildren: './pages/payment-confirmation/payment-confirmation.module#PaymentConfirmationPageModule' },
  { path: 'ultima-compra', loadChildren: './pages/last-purchase/last-purchase.module#LastPurchasePageModule' },
  { path: 'c', loadChildren: 'src/app/pages/shop/shop.module#ShopPageModule' },
  { path: 'order', loadChildren: 'src/app/pages/shop/components/order/order.module#OrderPageModule'},
  { path: 'b/:id/:q', loadChildren: 'src/app/pages/shop/shop.module#ShopPageModule' },
  { path: 'buscar/:id/:q', loadChildren: 'src/app/pages/shop/shop.module#ShopPageModule' },
  { path: 'a/:id', loadChildren: 'src/app/pages/product/product.module#ProductPageModule'},
  { path: 'p', loadChildren: 'src/app/pages/product/product.module#ProductPageModule'},
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
